import { ZETRIX_RESPONSE_MESSAGE } from "./requestEnum";
import {
  mainChainId,
  chainIdMessage,
  testChainIdMessage,
  switchAccountIdMessage,
} from "./dictionary";
import { mapMutations } from "vuex";
import ZetrixWalletConnect from "zetrix-connect-wallet-sdk";
import { isMobile, isChrome } from "./util";
import { authTokenService, tokenStorage } from "../services/authToken.service";

export default {
  data() {
    return {
      ztx: window.zetrix,
      isMobile: false,
      isChrome: false,
      zetrixWalletConnect: new ZetrixWalletConnect({ qrcode: false }),
      zetrixAccount: sessionStorage.getItem("zetrixAccount"),
      balance: this.$store.state.balance,
      isLogin: sessionStorage.getItem("isLogin"),
      errorNetwork: "",
    };
  },

  watch: {
    ztx: {
      deep: true,
      handler: function () {
        this.ztx.on("chainChanged", (res) => {
          if (res.code === 0) {
            this.setChainId(res.data.chainId);
            if (!this.isMainNetwork()) {
              this.disconnectWalletZtx();
            }
          }
        });
        this.ztx.on("switchAccount", (res) => {
          if (res.code === 0) {
            const newAddress = res.data.address;
            if (newAddress !== sessionStorage.getItem("zetrixAccount")) {
              // Token belongs to the old address — clear everything and force re-login
              tokenStorage.clearTokens();
              sessionStorage.clear();
              window.location.href = "/";
            }
          }
        });
      },
    },
  },

  mounted() {
    this.isMobile = isMobile();
    this.isChrome = isChrome();
    this.checkBalanceZTX();
    this.checkMobileApp();
  },

  updated() {
    this.checkWindowZetrix();
  },

  methods: {
    ...mapMutations([
      "setLogin",
      "setHeaderMessage",
      "setChainId",
      "setBalance",
    ]),

    checkWindowZetrix() {
      if (typeof window.zetrix !== "undefined") {
        this.ztx = window.zetrix;
      }
    },

    checkMobileApp() {
      if (this.isMobile || !this.isChrome) {
        this.zetrixWalletConnect.connect();
      }
    },

    checkBalanceZTX() {
      if (this.zetrixAccount !== null) {
        this.getAccountBalance(this.zetrixAccount);
      }
    },

    // 检查zetrix是否安装
    checkZetrixInstall() {
      if (this.isMobile) {
        // use connect wallet
        this.connectWalletMobileZetrix();
      } else if (this.isChrome) {
        if (typeof window.zetrix === "undefined") {
          alert("Zetrix Wallet not detected, please install and try again");
          if (
            window.confirm(
              "Proceed to open download page for Zetrix wallet extension?"
            )
          ) {
            window.open(
              "https://chrome.google.com/webstore/detail/zetrix-wallet-extension/faobkiaokccpmnhhefnobkbhnfjmbemh/"
            );
          }
        } else {
          this.ztx = window.zetrix;
          this.ztx.getChainId((res) => {
            if (res.code === 0) {
              this.setChainId(res.data.chainId);
              this.sendClientAuthorize();
            }
          });
        }
      } else {
        this.zetrixWalletConnect = new ZetrixWalletConnect({ qrcode: true });
        this.connectWalletMobileZetrix();
      }
    },

    sendClientAuthorize() {
      if (!this.isMainNetwork()) {
        this.$store.dispatch("triggerSnackbar", this.errorNetwork);
        return false;
      }
      this.ztx.authorize({ method: "changeAccounts" }, async (resp) => {
        if (resp.code === 0) {
          const address = resp.data.address;
          try {
            // 1. Get single-use nonce from ms-public-proxy
            const nonceResp = await authTokenService.getNonce(address);
            const nonce = nonceResp.data.nonce;

            // 2. Use sendRandom (wallet-integrated one-time sign) instead of signMessage
            //    This prevents the changeAccounts persistent listener from re-triggering signBlob
            this.ztx.authorize(
              { method: "sendRandom", param: { random: nonce } },
              async (resAuth) => {
                if (resAuth.code === 0) {
                  try {
                    // 3. Exchange signed nonce for access + refresh tokens
                    const { publicKey, signData } = resAuth.data;
                    const tokenResp = await authTokenService.createToken(address, publicKey, nonce, signData);
                    tokenStorage.setTokens(tokenResp.data.token, tokenResp.data.refreshToken);

                    sessionStorage.setItem("zetrixAccount", address);
                    this.zetrixAccount = address;
                    this.getAccountBalance(address);
                    this.isLogin = "true";
                    sessionStorage.setItem("isLogin", this.isLogin);
                    window.location.href = "/#/dashboard";
                  } catch (err) {
                    console.error("Token issuance failed:", err);
                    alert("Authentication failed. Please try again.");
                  }
                } else {
                  switch (resAuth.code) {
                    case 1:
                      alert(ZETRIX_RESPONSE_MESSAGE.CANCEL);
                      break;
                    case -1:
                      alert(ZETRIX_RESPONSE_MESSAGE.FAIL);
                      break;
                    default:
                      alert("Sign request failed. Please try again.");
                  }
                }
              }
            );
          } catch (err) {
            console.error("Failed to get nonce:", err);
            alert("Authentication failed. Please try again.");
          }
        } else {
          switch (resp.code) {
            case 1:
              alert(ZETRIX_RESPONSE_MESSAGE.CANCEL);
              break;
            case -1:
              alert(ZETRIX_RESPONSE_MESSAGE.FAIL);
              break;
            case 100001:
              alert(ZETRIX_RESPONSE_MESSAGE.CODE100001);
              break;
            case 100002:
              alert(ZETRIX_RESPONSE_MESSAGE.CODE100002);
              break;
            case 100003:
              alert(ZETRIX_RESPONSE_MESSAGE.CODE100003);
              break;
            case 100004:
              alert(ZETRIX_RESPONSE_MESSAGE.CODE100004);
              break;
          }
        }
      });
    },

    isMainNetwork() {
      const chainId = this.$store.state.chainId;
      const host = `${window.location.protocol}//${window.location.host}`;
      const url = process.env.VUE_APP_API_BASE_URL;

      if (
        (host.includes("localhost") ||
          host.includes("test") ||
          host.includes("dev") ||
          host.includes("sandbox") ||
          url.includes("localhost") ||
          url.includes("test") ||
          url.includes("dev") ||
          url.includes("sandbox")) &&
        chainId === mainChainId
      ) {
        this.setHeaderMessage({
          show: true,
          message: testChainIdMessage,
        });
        this.errorNetwork = testChainIdMessage;
        return false;
      } else if (
        !host.includes("localhost") &&
        !host.includes("test") &&
        !host.includes("dev") &&
        !host.includes("sandbox") &&
        !url.includes("localhost") &&
        !url.includes("test") &&
        !url.includes("dev") &&
        !url.includes("sandbox") &&
        chainId !== mainChainId
      ) {
        this.setHeaderMessage({
          show: true,
          message: chainIdMessage,
        });
        this.errorNetwork = chainIdMessage;
        return false;
      }
      this.setHeaderMessage({
        show: false,
        message: "",
      });
      return true;
    },

    async connectWalletMobileZetrix() {
      try {
        await this.zetrixWalletConnect.connect();
        const res = await this.zetrixWalletConnect.auth();
        const address = res.data.address;

        // 1. Get single-use nonce
        const nonceResp = await authTokenService.getNonce(address);
        const nonce = nonceResp.data.nonce;

        // 2. Sign the nonce with the mobile wallet
        const signResult = await this.signMessageMobileZtx(nonce);
        if (!signResult) {
          return false;
        }

        // 3. Exchange signed nonce for tokens
        const { publicKey, signData } = signResult.data;
        const tokenResp = await authTokenService.createToken(address, publicKey, nonce, signData);
        tokenStorage.setTokens(tokenResp.data.token, tokenResp.data.refreshToken);

        sessionStorage.setItem("zetrixAccount", address);
        this.zetrixAccount = address;
        this.getAccountBalance(address);
        this.isLogin = "true";
        sessionStorage.setItem("isLogin", this.isLogin);
        window.location.href = "/#/dashboard";
      } catch (err) {
        console.error("Mobile wallet authentication failed:", err);
        return false;
      }
    },

    getAccountBalance(zetrixAccount) {
      this.$store
        .dispatch("wallet/getAccountBalance", { zetrixAccount: zetrixAccount })
        .then((response) => {
          if (response != null) {
            this.setBalance(response.balance);
            this.balance = response.balance;
          } else {
            this.setBalance(0);
            this.balance = 0;
          }
        });
    },

    signBlob(blob) {
      return new Promise((resolve) => {
        setTimeout(() => {
          if (typeof this.ztx !== "undefined") {
            this.ztx.signMessage({ message: blob }, function (result) {
              if (result.code === 0) {
                return resolve(result);
              }
              return resolve(false);
            });
          } else {
            return resolve(false);
          }
        }, 0);
      });
    },

    signBlobMobileZtx(blob) {
      return new Promise((resolve) => {
        setTimeout(() => {
          this.zetrixWalletConnect
            .signBlob({ message: blob })
            .then((res) => {
              if (res.code === 0) {
                return resolve(res);
              } else {
                return resolve(false);
              }
            })
            .catch((e) => {
              return resolve(false);
            });
        }, 0);
      });
    },

    signMessageMobileZtx(blob) {
      return new Promise((resolve) => {
        setTimeout(() => {
          this.zetrixWalletConnect
            .signMessage({ message: blob })
            .then((res) => {
              if (res.code === 0) {
                return resolve(res);
              } else {
                return resolve(false);
              }
            })
            .catch((e) => {
              return resolve(false);
            });
        }, 0);
      });
    },

    disconnectWalletZtx() {
      if (this.isMobile || !this.isChrome) {
        this.zetrixWalletConnect.disconnect();
      }
      tokenStorage.clearTokens();
      sessionStorage.clear();
      window.location.href = "/";
    },
  },
};
